import { useEffect, useState } from "react";
import { merge, type Observable, Subject, tap, timeInterval, bufferCount } from "rxjs";

type NetworkQualityLevel = import("twilio-video").NetworkQualityLevel | null;

type Props = {
  qualityChanged$?: Observable<NetworkQualityLevel> | null;
  meetingId: string;
  partyId: string;
  participantRole: string;
};

const TERMINAL = "completed";

export function useNetworkQualityLevel({
  qualityChanged$,
  meetingId,
  partyId,
  participantRole,
}: Props) {
  const [networkQualityLevel, setNetworkQualityLevel] = useState<null | number>(null);
  useEffect(() => {
    if (!qualityChanged$) {
      return;
    }
    const end$ = new Subject<typeof TERMINAL>();
    const sub = merge(end$, qualityChanged$)
      .pipe(
        tap((level) => setNetworkQualityLevel(level === TERMINAL ? null : level)),
        timeInterval(),
        bufferCount(2, 1),
      )
      .subscribe(([previous, current]) => {
        // eslint-disable-next-line no-console
        console.log(
          JSON.stringify({
            event: "Network quality level changed",
            meetingId,
            participantRole,
            participantId: partyId,
            previousQualityLevel: previous.value,
            previousQualityDuration: current.interval,
            newQualityLevel: current.value,
          }),
        );
      });
    return () => {
      end$.next(TERMINAL);
      sub.unsubscribe();
    };
  }, [qualityChanged$, meetingId, partyId]);

  return { networkQualityLevel };
}
